var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-primary',{attrs:{"text":_vm.btnText,"type":"submit","flex-row-reverse":"","disabled":_vm.totalItens === 0,"loading":_vm.loading},on:{"click":function($event){return _vm.confirmTerminate()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }